<div
    class="modal-content-container"
    [ngClass]="{
        'has-app-banner': showAppBanner
    }"
>
    <ng-template #container></ng-template>
</div>
